// services/budgetApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  ApiReportsResponse,
  GetBudgetStatisticsResponse,
  BudgetData,
} from '../../../types/reports';
import { baseQueryWithReauth } from '../baseQuery';

export const budgetReportsService = createApi({
  reducerPath: 'budgetReportsService',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getBudgetStatistics: builder.query<GetBudgetStatisticsResponse, void>({
      query: () => ({
        url: `/jobs/v1/operator-budget-reports/statistics`,
      }),
    }),
    getBudget: builder.query<ApiReportsResponse<BudgetData>, string>({
      query: (params) => ({
        url: `/jobs/v1/operator-budget-reports?${params}`,
      }),
    }),
    exportBudget: builder.query<any, { params: string; format: string }>({
      query: ({ params, format }) => ({
        url: `/jobs/v1/operator-budget-reports/export-${format}?${params}`,
        responseHandler: async (response) => await response.blob(),
      }),
    }),
  }),
});

export const {
  useGetBudgetStatisticsQuery,
  useGetBudgetQuery,
  useLazyExportBudgetQuery,
} = budgetReportsService;
